import React, { Component } from 'react';
import { throttle } from 'lodash';

import './styles/Imports.css';
import './styles/Normalize.css';
import './styles/Din.css';
import './styles/Milligram.css';
import './styles/Sharer.css';
import './styles/App.css';

import Titulo from './components/Titulo';
import TituloSec0 from './components/TituloSec0';
import TituloSec from './components/TituloSec';
import TituloSec2 from './components/TituloSec2';
import TituloFilete from './components/TituloFilete';
import SubtituloFilete from './components/SubtituloFilete';
import Cita from './components/Cita';
import Mancheta from './components/Mancheta';
import Sharer from './components/Sharer';
import Imagen from './components/Imagen';
import ImagenBg from './components/ImagenBg';
import Cifra2 from './components/Cifra2';
import ApoyoDiccionario from './components/ApoyoDiccionario';
import Libros from './components/Libros';
import Footer from './components/Footer';
import Firma from './components/Firma';
import Barbaros from './components/Barbaros';

import { Block, Center, Full, Dropcap, DropcapSmall, DropcapNext } from './styles/estilos';
import { Icon1, Icon2, Icon3, Icon4, Icon5, Icon6, Icon7 } from './styles/icons';
import { referrer } from './utils/referrer';

const delay = 200;

class App extends Component {
  state = {
    referrer: '',
    width: window.innerWidth,
    height: window.innerHeight,
  };

  componentDidMount() {
    const r = referrer(this.props.referrer);
    this.setState({
      referrer: r,
    });

    window.addEventListener('resize', throttle(this.handleResize, delay));
  }

  handleResize = event => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  render() {
    return (
      <div className="App">
        <Center>
          <Mancheta referrer={this.state.referrer} />
          <Barbaros />
          <Titulo />
        </Center>

        <Full>
          <Imagen
            full
            width={this.state.width}
            name="1"
            firma="Lourdes de Vicente"
            pie="Antonio Serrano Cueto (catedrático de Latín) y Rafael Gallé (catedrático de Griego), junto a las estatuas romanas del Museo de Cádiz."
          />
        </Full>

        <Block>
          <SubtituloFilete contenido="La necesidad de unos itinerarios externos y la presencia de las lenguas clásicas como base en las filologías, principales reivindicaciones. “Parece que toda la ciencia tiene que ser de bata blanca”" />
          <Firma contenido="Pilar Vera" />

          <p>
            <Dropcap>L</Dropcap>
            <DropcapNext>os bárbaros,</DropcapNext> para los griegos, eran los que balbuceaban: la otredad no la daban
            la piel o la geografía, sino la lengua. Al cabo de los siglos, los que aprenden y enseñan las lenguas
            clásicas han terminado siendo los “bárbaros”, los otros, los que chapurrean cosas incomprensibles. Si las
            humanidades son el flanco débil del conocimiento en época de utilitarismo rampante –y de precariedad
            rampante–, el centro de ese flanco son las lenguas clásicas. Para qué sirven. Qué pintan hoy en día, si
            total. Hablamos con Rafael Gallé, catedrático de Filología Griega en la UCA; Antonio Serrano Cueto, catedrático en
            Filología Latina; y Carmen Gutiérrrez, profesora de clásicas en el IES Jorge Juan de San Fernando.
            “Realmente, la gran bestia negra de la que estamos hablando todo el rato –dice Rafael Gallé– es la utilidad
            inmediata”.
          </p>
          <p>
            Los tres aseguran estar hartos de pasarse la vida justificando lo que hacen. Los tres adoran lo que hacen.
          </p>
        </Block>
        <Full>
          <Imagen
            full
            width={this.state.width}
            name="mesa"
            firma="jesús marín"
            pie="Los profesores Rafael Gallé, Carmen Gutiérrez y Antonio Serrano Cueto."
          />
        </Full>
        <Block>
          <h4>Para qué sirven las clásicas </h4>

          <Icon1>
            Esa es la gran pregunta: “Una pregunta que no le hacen, por ejemplo, a alguien que estudie la Revolución
            Norteamericana”, razona Rafael Gallé. “Cuando todo no estaba tan mercantilizado, se cuestionaba algo menos
            –desarrolla Antonio Serrano Cueto–; pero ahora que se busca la inmediatez y lo acrítico, donde tanto un
            equipo de gobierno como un sistema de viabilidad universitario se hacen con criterio mercantilista, pues
            nosotros representamos justo lo contrario. Nadie se cuestiona que la democracia viene de Atenas, pero sí se
            cuestiona la base de las clásicas desde el punto de vista filológico”.
          </Icon1>
          <p>
            "Las lenguas clásicas marcan una diferencia fundamental en los campos de las filologías: pero la enseñanza
            de idiomas se ha dividido hasta tal punto que se imparten desde compartimentos estancos e impermeables”,
            continúa Rafael Gallé. Desde fuera, no entra dentro de la lógica que Latín y Griego se desestimen del punto
            de partida de las filologías modernas, cuando son clave léxica en la mayor parte de lenguas europeas. Su
            aprendizaje otorga, como si dijéramos, un plus de flexibilidad lingüística. “Y luego están el aspecto
            estético y literario de la lengua –apunta Carmen Gutiérrez–: no puedes entender del todo a Shakespeare o a
            Cervantes, como dos ejemplos muy básicos, si no conoces los clásicos”.
          </p>
          <p>
            La permeabilidad lingüística es la más evidente, seguida de la literaria, que abre puertas hasta la
            actualidad (vanguardias incluidas): “Pero también se entienden mejor la estética o los movimientos
            artísticos”, indica Serrano Cueto. Esa es precisamente la gran cualidad del latín y griego: su
            transversalidad. “Podemos ver la Primavera de Botticelli, y ver que es fabulosa, gustarnos mucho, etc. Pero
            si sabemos lo que decía Séneca sobre las Tres Gracias, lo entendemos mejor, lo disfrutamos mucho más. Y así
            con todo, porque el mundo clásico nos ha influido de manera tremenda a nivel simbólico y artístico, y lo
            sigue haciendo. Cuántos mitos no recontaremos de Ovidio, cuyos escritos pasaban por ser la Biblia de los
            Gentiles”.
          </p>

          <h4>Ya está todo traducido, ¿no? </h4>
          <Icon2>
            Sobra decir que una traducción del siglo XVIII puede tener poco que ver con una traducción actual. Hay
            términos o acepciones que caen, términos que se añaden. Hay aspectos que se creyeron ver entonces, o que
            creemos ver ahora, y los subrayamos. Porque los textos clásicos tienen cualidad de bulbo: pueden eclosionar,
            como de la nada, a cada temporada.
          </Icon2>
          <p />
          <h4>Si se llaman lenguas muertas, es por algo </h4>

          <Icon3>
            Hay quien intenta que esto no sea así. El método Olberg propone una enseñanza de las lenguas clásicas a partir
            del llamado “método activo”: aplicar los principios que se aplican a una lengua moderna, hablar con los
            alumnos y animarles a hablar en latín o en griego. “Se practica en algunos institutos y por supuesto tiene
            sus defensores. ¿Qué ocurre? Que los alumnos tardan muchísimo más tiempo en poder acercarse a un texto
            clásico y traducirlo (que es el objetivo de estudiar estas lenguas), mientras que en un par de años, un
            estudiante del medio convencional puede entender a uno de los autores fáciles, a un Julio César, a un
            Herodoto”.
          </Icon3>
          <p>
            La clave es que pueden ser lenguas muertas, pero están vigentes: palpitan por debajo de lo que barbareamos
            –o algo así dirían ellos– en gran parte del continente. “Tú puedes aprender a hablar francés, que si no
            tienes fundamentos de latín y griego no llegas a profundizar”, indica Carmen Gutiérrez. Además de la
            presencia y actualización del imaginario del mundo clásico, aunque no lo reconozcamos de inmediato: “Ocurre,
            también, que en muchos autores del pasado las referencias al mundo clásico eran casi connaturales y ni
            siquiera necesitaban explicarlas –indica Rafael Gallé–: el referente era automático. Ahora, se está
            convirtiendo en algo críptico”.
          </p>
          <Cita
            contenido="Deberíamos seguir la analogía de las abejas e ir recogiendo entre distintos saberes"
            nombre="Carmen Gutiérrez"
            cargo="Profesora de clásicas"
          />
          <p>
            Carmen Gutiérrez menciona también la retórica, una disciplina que “ha estado presente desde siempre a nivel
            académico en Inglaterra y Estados Unidos, y a la que la retórica clásica da cuerpo y ritmo. Eso, ahora
            mismo, es algo absolutamente puntero”.
          </p>
          <p>
            “La cuestión está en esa analogía de las abejas y las arañas –continúa–: deberíamos ser como las abejas, e
            ir recogiendo de muchos saberes distintos, aportando a todos los interrogantes para hacer surgir algo
            nuevo”.
          </p>

          <h4>Son saberes accesorios</h4>

          <Icon4>
            Una concepción que empieza, aseguran los tres, en los institutos. “En principio, sobre el papel, el reparto
            de clásicas no está mal”, dice Carmen Gutiérrez. En primero de Bachillerato de Humanidades, el Latín es
            obligatorio; Griego es optativo siempre: “Esto ya da un carácter de debilidad al cupo de clásicas en los
            institutos –explica–. Los itinerarios no se configuran desde arriba, sino que los configuran los centros
            según demanda y, también, según lo que se considera que es más útil (o inútil)”. Y ha habido casos en los
            que se ha tenido que defender la vigencia de una asignatura de Griego aunque se cumpliera el cupo suficiente
            de alumnos. “A nadie se le ocurre hacer eso con otra asignatura”, apunta Gallé. “Sin olvidar –dice Serrano
            Cueto–, que es frecuente que se aconseje cambiar de idea a los alumnos más brillantes que quieran estudiar
            Humanidades”.
          </Icon4>

          <Imagen width={this.state.width} name="2" firma="Lourdes de Vicente" pie="" />

          <h4>El que no vale, para sociales </h4>

          <Icon5>
            Un insulto a las competencias. Entre las que desarrolla el filólogo clásico, el valor del esfuerzo – no está
            acostumbrado a la recompensa inmediata y fácil–. “Y la capacidad para comprender un lenguaje interconectado
            –indica Antonio Serrano Cueto–. El hábito de una metodología. La desenvoltura respecto a su propia lengua es
            mucho mayor: crece muchísimo, claro, porque está nutriendo la raíz. Además de la flexibilidad para aprender
            otras lenguas. Si haces Historia, hasta hace un par de siglos, el latín era básico en las relaciones
            diplomáticas: te va a facilitar el acceso directo a fuentes”.
          </Icon5>
          <p>
            “Está demostrado, además –continúa–, que trabajar con la sintaxis favorece muchísimo las conexiones
            neuronales”, sin olvidar la carga emocional, indirecta: al ver lo común en lo diferente, lo ajeno no parece
            algo inabarcable.
          </p>
          <p>
            Otro cliché asumido es que los filólogos no son investigadores: “No todos los investigadores llevan bata
            blanca y están en un laboratorio”.
          </p>

          <h4>No hay salidas</h4>

          <Icon6>
            “Uno de los grandes éxitos de la Facultad de Filosofía y Letras ha sido la creación de dobles grados
            –explica Rafael Gallé–, que permiten la combinación de distintas filologías y lingüística, abriendo así las
            puertas al alumnado en Estados Unidos, Rusia... cosa que antes no se contemplaba”.
          </Icon6>

          <Cita
            contenido="Uno de los grandes logros de la UCA ha sido la creación de los dobles grados"
            nombre="Rafael Gallé"
            cargo="Catedrático de Griego"
          />

          <p>
            “Además –prosigue Gutiérrez–, el margen de oposiciones es mayor que en cualquier filología: compara los
            sesenta que se pueden presentar a veinte plazas de Griego con los miles que se presentan a las plazas de
            Inglés”.
          </p>

          <p>
            “Hay que tener en cuenta, además, que esta es una carrera muy vocacional (en gran medida, gracias a la labor
            de los profesores de instituto que hacen que los alumnos se enamoren del Latín y el Griego). Además, que lo
            principal para hacer bien las cosas es dedicarte a algo que te gusta, y después ya ves cómo te buscas la
            vida”, explica Gallé.
          </p>

          <h4>Es la lengua de la Iglesia; tiene carácter elitista. </h4>

          <Icon7>
            “Creo que, sobre todo al Latín, le ha pesado durante mucho tiempo su asociación con la Iglesia, y por
            asunción, con los valores más tradicionales, con lo reaccionario y aburrido. Lo que indica un gran
            desconocimiento, por que el Latín clásico, por ejemplo, no es ni mucho menos el de la Iglesia”, explica
            Serrano Cueto, que apunta también que uno de los grandes valores del departamento de clásicas en la UCA ha
            sido el incluir el latín renacentista y el griego de época helenística y romana.
          </Icon7>

          <Cita
            contenido="Si sacas el Latín y el Griego de los márgenes, el enriquecimiento es bestial"
            nombre="Antonio Serrano Cueto"
            cargo="Catedrático de Latín"
          />

          <p>
            “Ni somos élite, ni vamos de élite, ni queremos provocar un sentimiento de inferioridad en la gente: lo que
            queremos es que la gente disfrute más de las cosas. Si sacas el Latín y el Griego de los márgenes, el
            enriquecimiento es bestial –se explica Serrano Cueto–. Por ejemplo, si miras la Capilla Sixtina, y ves ahí a
            la Sibila, y te preguntas por qué está ahí con los profetas, sabes que es un ejercicio de sincretismo a
            partir de una égloga de Virgilio cristianizada. Todo ese bagaje de cultura que nos ha dejado el mundo
            clásico no se ha sabido comunicar”.
          </p>
        </Block>

        <Full>
          <ApoyoDiccionario titular="Hablamos latín y griego" />
          <Imagen
            full
            width={this.state.width}
            name="ies1"
            firma="Sonia Ramos"
            pie="Rosalía Loreno, Álvaro Ramírez y María Fresneda, integrantes del premiado grupo ‘Harpías’ del IES Pablo Ruiz Picasso, junto a sus profesores Margarita Gómez y José Manuel Martos."
          />
        </Full>
        <Block>
          <TituloSec0 />
          <SubtituloFilete contenido="Alumnos de Chiclana explican por qué eligen lenguas clásicas contra las presiones de compañeros y familiares" />
          <p>
            Algunos compañeros, con la saña de los adolescentes, les llaman letrasados. “A mí me han llegado a llamar
            letrosa” dice María, estudiante de segundo de Bachillerato, con más humor que dolor al contar las bromas que
            sufre por haber elegido estudiar Latín y Griego, Cultura Clásica. Burlas de quienes comparten bancos, y
            presiones por parte de la familia, sobre la supuesta falta de salidas profesionales para quienes enfilan su
            carrera hacia las Humanidades, no arredran a este pequeño grupo de alumnos del IES Pablo Ruiz Picasso de
            Chiclana, que han decidido disfrutar estudiando lo que les gusta. Una forma de encarar su propia formación
            que les ha llevado hace unos meses a ganar la fase nacional del Concurso Odisea, convocado para bachilleres
            de toda España y con la cultura clásica, el mundo grecolatino, como tema.
          </p>
          <p>
            En un aula metafóricamente demasiado grande para su número, se convocan para el periodista la profesora de
            Latín Margarita Gómez, el de Griego José Manuel Martos, y los alumnos de segundo de Bachillerato Álvaro
            Ramírez, María Fresneda y Rosalía Loreno, integrantes del grupo Harpías que ganó el Concurso Odisea. Además,
            Paula Fresneda (sí, hermana de María), Carmen Hernáiz y Lucía Rivera, de cuarto de ESO, junto con Ana Isabel
            Esteban, Daniel Cavilla, de primero de bachillerato, y Sofía Khalatiuk, de segundo. Estupendos estudiantes.
          </p>
          <p>
            El profesor de Griego se queja del desprestigio que sufren estas disciplinas en España, “víctimas de esa
            mercantilización de la enseñanza que defiende que no tienen utilidad, al contrario que la rama de Ciencias”.
            Lamenta que no sigamos la estela de países como Alemania y Bélgica, “que incluso se está planteando aumentar
            las horas de latín” en sus planes de estudio.
          </p>

          <Cifra2
            numero1="9.000"
            clave1="matriculaciones en latín, griego y cultura clásica en los institutos de la provincia"
            numero2="6.289"
            clave2="en latín, y 1.774 en griego. lo normal es que quien hace griego, también cursa latín"
          />

          <p>
            Margarita ve como culpables de la “lenta extinción” de estas asignaturas al Gobierno que eliminó su
            obligatoriedad en los institutos hasta llegar al Bachillerato, y a las directivas de algunos centros, que
            podrían ofertarlas más o con más ganas: “Afortunadamente, en este instituto nos miman, en otros algunos
            pueden haber tenido algún conocimiento de latín, pero desde luego no de griego. Si no se oferta no hay
            alumnos, y si no hay alumnos no hay profesores...”
          </p>
          <p>
            El optimismo lo ponen los estudiantes, auténticos conversos a las Humanidades después de haberse dejado
            arrastrar por la gran corriente de las Ciencias. Álvaro es de estos: convencido de su utilidad, estaba a
            punto de meterse en bachillerato de Tecnología, pero asistió a una charla (los entusiastas profesores de
            clásicas van por las clases haciendo propaganda de sus materias) sobre latín y griego. “Y entonces tomé una
            de las mejores decisiones de mi vida. Debemos hacer lo que nos llama, no lo que creemos que tiene más
            salidas. Porque si de verdad lo buscas, seguro que encuentras una salida”.
          </p>
          <p>
            María es la emotiva del grupo. Le pueden saltar lágrimas hablando de lo que le gusta y de lo que debe a sus
            profesores. Y lloró cuando allí mismo le comunicaron que le habían otorgado una Matrícula de Honor, una de
            las siete otorgadas este curso en el instituto y de las tres dadas a alumnos de Humanidades.“Desde siempre
            me ha encantado aprender cosas nuevas -declara- y desde luego yo he madurado aprendiendo la cultura
            greco-latina. Me gusta porque para aprender lo de hoy hay que conocer el pasado. Todo tiene su historia y
            desde luego hay que tener en cuenta nuestros orígenes”. Eso.
          </p>

          <Cifra2
            numero1="3 de 7"
            clave1="casi la mitad de las matrículas de honor del ies ruiz picasso, a alumnos de humanidades"
            numero2="937"
            clave2="en cultura clásica en los centros gaditanos, también pueden dar latín y griego"
          />

          <p>
            A su lado, Rosalía cuenta: “Yo era como casi todos, que soñaba con hacer Ciencias... hasta que di con la
            Química y me dije 'esto no es lo mío'. Cambié de centro, di con magníficos profesores y me sentí apoyada
            ante el bullying a las lenguas supuestamente muertas. Gracias a la etimología he entendido muchas otras
            cosas, el latín y el griego no son sólo sintaxis sino saber la cultura de esa época, te ayudan a expresarte
            bien”.
          </p>
          <p>
            Paula es la hermana pequeña de María. “Yo lo descubrí antes que tú, en realidad fui yo quien la metió”,
            bromea. En su caso, la Mitología greco-latina fue la puerta de entrada para unos estudios que de momento
            piensa que le llevan hacia el Bachillerato de Arte. Carmen, que quiere ser periodista, compartió con Paula
            ese taller de Mitología y, como ella, cayó en las redes clásicas por ese camino, a pesar que su familia le
            insiste en que “aún estoy a tiempo de cambiar el bachillerato de Humanidades por el de Sociales, y hasta en
            la comida de Nochebuena me dieron la lata... pero yo sigo decidida”.
          </p>
          <Imagen width={this.state.width} name="ies2" firma="Sonia Ramos" pie="" />
          <p>
            En cambio Lucía, futura maestra, dio con el Latín de casualidad al coger Cultura Clásica, y aún se le
            resiste: pero como le gusta mucho la Historia lo ve imprescindible, y sí: “Ahora me gusta un montón”. Ana
            Isabel es la más reivindicativa, y eso que le costó darse cuenta de sus preferencias. “Desde pequeña me
            encantaba la Mitología, pero pensaba que no servía para las Humanidades. En tercero di latín y economía y
            ahí ya me motivé”. Sin embargo, denuncia a su manera lo que llama “el estrés de los de Ciencias, que nos
            llaman letrasadas. Y mis padres, que me dicen que a dónde voy a ir con esto, que voy a tener que vivir
            debajo de un puente. Quiero estudiar Filología Clásica, pero si no cuela, haré Traducción e Interpretación”.
          </p>
          <p>
            Un caso raro y sorprendente es el de Sofia Khalatiuk, ucraniana de segundo de bachillerato y ganadora de
            otra de las matrículas de honor de este año. Haciendo honor a su nombre, que en griego significa sabiduría,
            es una estupenda estudiante de Ciencias, pero se decidió por las Letras “porque me gustan”. Habla seis
            idiomas y ha vivido en su país natal y en Italia antes de llegar a Chiclana, donde lleva apenas dos años y
            articula un discurso en un castellano casi perfecto. No comprende por qué el bachillerato de Ciencias tiene
            aquí mucho más prestigio que el de Humanidades. “En Italia es al revés, el más exigente es el llamado
            Bachillerato Clásico, y los que no pueden acceder a él son los que van a Ciencias”.
          </p>
          <p>
            Daniel es callado, dicen sus profesores, pero no lo parece cuando interviene al asegurar que “desde
            chiquillo” tenía claro que iba a hacer una carrera de Letras. Suelta una retahíla de palabras griegas cuando
            dice que le encantan “la sintaxis, la morfología, la semántica...”. Eso sí, sus padres siempre le apoyaron.
            Sus compañeros le dicen que esos estudios no tienen salida. “Pero yo digo que no hay carreras con salidas,
            sino personas con salidas”, afirma con seguridad. Y deja con la boca abierta a sus profesores.
          </p>
        </Block>

        <Full>
          <ImagenBg full width={this.state.width} name="il1" firma="" pie="" />
        </Full>

        <Block>
          <TituloSec />
          <p>
            Cuando hablamos de la vigencia del mundo clásico, la mente vuela hacia Monty Python: “¿Qué nos han dejado
            los romanos?”. Veamos, a vuelapluma. ¿Vivimos en casas con patio y corrala? Como ellos. ¿Navidades?
            Saturnalias mítricas. ¿Ellos hacían pintadas? Nosotros hacemos pintadas. Tú los llamas gladiadores, yo los
            llamo futbolistas. ¿Se pasaban el día en el foro? Nos pasamos el día en el Twitter.
          </p>
          <p>
            El legado sigue pegajoso 1500 años después. Y no es que no tenga su espacio. Nunca antes se han publicado
            tantas traducciones de obras clásicas. No son pocos los títulos relacionados con el mundo clásico que trepan
            a la lista de los más vendidos –todo lo que firma Mary Beard suele ser un éxito, y existen bestsellers
            inesperados, como La lengua de los dioses de Andrea Marcolongo–. La vigencia de los mitos y referencias del
            mundo griego se pone de manifiesto en el recuento constante de sus historias, como la última propuesta de
            las Niñas de Cádiz, que cuentan la Lisístrata de Aristófanes en clave de cabaret gaditano.{' '}
          </p>
          <p>
            La profesora, traductora y poeta Aurora Luque destaca las “extraordinarias posibilidades de relectura y
            aprovechamiento” de los temas clásicos. Luque se encuentra traduciendo Las suplicantes de Esquilo, “la
            historia de unas mujeres refugiadas que huyen de matrimonios forzados. Asilo político y violencia contras
            las mujeres, ¿qué puede haber más actual? Cortar el puente a esas reflexiones es una irresponsabilidad”.
          </p>
          <p>
            No deja de ser significativo que, junto al amor que parecen despertar la historia y herencia clásicas,
            conviva el arrinconamiento de sus lenguas: “El último escalón de la caída fue con Wert, pero ya venía de
            lejos. Quizá ahora se pueda plantear un cambio. Aunque parece que no existe interés en fomentar un
            conocimiento más profundo o especializado de la historia o de la lengua. Se habla mucho de la pérdida de
            valores en Europa, pero yo creo que, con la erradicación de las lenguas clásicas, vivimos un suicidio
            cultural”.{' '}
          </p>
          <p>
            La labor de quien trabaja las palabras a nivel profundo no está tan alejada de la de quien desarrolla un programa
            informático: por algo también se llama “lenguaje”. En ambos casos se ejercita la capacidad analítica. Todo
            tiene que encajar como en un tetris. Los expertos en Inteligencia Artificial sostienen que es impensable
            desarrollar un proyecto sin psicólogos o lingüístas. Jonathan Evans, ex director del MI5, declaraba en una
            entrevista que saber latín y/o griego era un punto a favor para los agentes, porque indicaba “una buena
            capacidad intelectual, la habilidad de detectar conexiones y la destreza de asimilar y analizar una gran
            variedad de material”.
          </p>
          <p>
            Quien se interesa por las clásicas, indica Aurora Luque, hace gala de “inquietud intelectual, de ganas de
            saber, de indagar: esto es importantísimo. Además, profundizar en el conocimiento de la lengua es una de las
            formas más directas de enriquecer tu pensamiento”.{' '}
          </p>
          <Libros />
          <p>
            Para el psicólogo y decano en Ciencias de la Educación, Manuel García Sedeño, la tendencia a “entender las
            cualidades personales a partir de distintas formas de argumentar, pensar... supone un gran error: aunque hay
            conocimientos que ayudan a mejorar las formas de expresar las ideas, como el lenguaje oral o el matemático,
            eso no significa que las personas que las utilizan tengan mayores cualidades: sólo tienen habilidades
            diferentes”. Admite que, en la historia, “el uso del lenguaje matemático se ha entendido como la habilidad
            de una mente prodigiosa, pero también –matiza– existieron figuras que cambiaron el mundo desde la filosofía,
            la música o cualquier otra disciplina. Estamos sólo ante una forma social de entender el conocimiento”.{' '}
          </p>
          <p>
            “No sé por qué se llama Humanidades a las Humanidades, cuando son las dos cosas, ciencias y letras, las que
            realmente definen a los humanos”, comenta Ignacio Moreno, especialista en Microbiología en el Instituto de
            Ciencias Marinas de Andalucía, que manifiesta su preocupación por el “ritmo impuesto a los jóvenes
            científicos hoy día (los mismos que están sumidos en la precariedad). Un ritmo que les impide pararse a
            imaginar. Se busca publicar mucho, muy rápido y en revistas de impacto lo más alto posible, pero a veces se
            pierde de vista la parte artística de la investigación, las soluciones creativas, los cambios de
            perspectiva”. Moreno señala también la importancia del lenguaje aun en las ramas más puras de la ciencia y
            la tecnología: “Si no sabemos expresarnos, difícilmente sabremos pensar, y el orden en las ideas es vital en
            la labor de un científico. Carl Sagan, Isaac Asimov o Konrad Lorenz son ejemplos de científicos que eran,
            además, excelentes escritores y divulgadores”.{' '}
          </p>
          <p>
            En efecto, una cosa no está reñida con la otra. Para apuntalar este hecho, García Sedeño señala que la
            popular especialización entre hemisferios cerebrales no es más que un mito, aunque sí hay “datos que
            defienden la localización de ciertas capacidades en zonas concretas del cerebro”. Pero hay capacidades que
            también escapan a esto: “La creatividad, por ejemplo, no sólo no está localizada sino que es hasta difícil
            de definir neurológicamente”.{' '}
          </p>
          <p>
            De hecho, de estar en algún sitio, parece que la creatividad reside en la capacidad para realizar conexiones
            originales. Y una clave para ello es la mezcla de perspectivas, referencias o saberes. El “caminar a hombros
            de gigantes”, que decía Newton. Tomemos el caso de Ada Lovelace, que ha pasado a la historia como la primera
            programadora. Ada fue criada por su madre con un programa educativo centrado en la ciencia y el empirismo
            puro –con lord Byron como padre, su progenitoria asociaba cualquier cosa relacionada con la poesía como un
            camino hacia la perdición y la locura–. Aun así, la niña manifestaba una tendencía a “distraerse”; es decir,
            a ensoñarse. Si algo destacaban de ella sus colegas era su capacidad para discurrir ideas nunca vistas.{' '}
          </p>
          <p>
            “Los distintos saberes no sólo pueden cooperar sino que, en muchos casos, son manifestaciones diferentes de
            las mismas capacidades –apunta Manuel García Sedeño–. Por ejemplo, podemos escribir un relato o un poema
            mediante el lenguaje común, el musical o el pictórico. Incluso me atrevería a decir que también mediante el
            lenguaje matemático. Por tanto, se puede concebir como la misma capacidad manifestada a través de diferentes
            lenguajes en función de las habilidades de cada uno”.{' '}
          </p>
          <p>
            Para García Sedeño, la división abismal que el pensamiento social ha creado entre letras y ciencias es “muy
            pobre y fruto del reduccionismo extremo”. Tanto él como Aurora Luque culpan al “carácter excesivamente
            mercantil” de la sociedad del demérito de las Humanidades: “La ciencia es una –insiste García Sedeño–. Todas
            las disciplinas son necesarias, se necesitan e interactúan, ninguna puede existir sin las demás: la división
            que hacemos de ellas es puramente social y artificial”.{' '}
          </p>
        </Block>

        <Full>
          <ImagenBg full width={this.state.width} name="il2" firma="" pie="" />
        </Full>
        <Block>
          <TituloFilete titulo="Opinión" />

          <TituloSec2 />
          <p>
            <DropcapSmall>E</DropcapSmall>
            <DropcapNext>s muy conocida la anécdota,</DropcapNext>pero no me resisto a contarla. El escritor inglés Patrick Leigh Fermor comandó durante la II Guerra Mundial el grupo que se encargó en Creta de secuestrar al general Kreippe, jefe de las tropas alemanas invasoras en esa isla griega. En un descanso en el duro camino que los llevó a través de las montañas hacia el puerto que había de evacuar al militar a Egipto, Kreippe comenzó a recitar en latín una Oda de Horacio, y para su sorpresa, el que parecía rudo guerrillero continuó y acabó el recitado perfectamente. Obviamente, los dos enemigos bélicos habían estudiado con provecho el Latín. La coincidencia, natural en dos personas leídas de la épcoa, hizo mucho más fácil la culminación de la operación..
          </p>
          <p>Digo yo que no habría que esperar a que ocurrieran acciones de guerra para darnos cuenta de la importancia y la vigencia de las supuestas lenguas muertas, y más si simplemente caemos en la cuenta de que algunas como el latín y el griego son en verdad nuestras propias lenguas. Nadie pretende hablar en latín en los tiempos actuales, pero tener un mínimo conocimiento del idioma de los antiguos romanos me hizo sonreír, e incluso sentir la engañosa emoción de estar por un momento en medio de un peplum, cuando oí por primera vez a los italianos actuales saludarse con un casi imperial Salve!
          </p>
          <p>Es igualmente gratificante escuchar a los alumnos que todavía hoy eligen con entusiasmo el Latín y el Griego como asignaturas optativas decir que lo hacen porque les gusta, porque vibran con la etimología de las palabras, porque viven un descubrimiento cada vez que comprenden el origen de una palabra. Porque de pronto se sienten conectados, con un hilo invisible e inmortal, con los humanos que construyeron calzadas, con los artistas aquellos que idearon y realizaron el Partenón, con los que empezaron a enseñarnos el mundo con la Filosofía y el Teatro. Y con la democracia.
          </p>
          <p>Y una palabra, una sola, no digamos ya una lengua, tiene ese poder. Si no las cuidamos, nos perderemos en la historia como el astronauta al que se le rompió el cordón con su nave. Para siempre, irremisiblemente.</p>
        </Block>
        <Block>
          <Sharer />
          <Footer referrer={this.state.referrer} />
        </Block>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js